import { writable } from 'svelte/store';
import collect from 'collect.js';
import dayjs from 'dayjs';
// Models
import UserBettingStat from '@/Models/UserBettingStat';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getUserBetStats(userId, from = dayjs(), to = dayjs()) {
			const betStats = new UserBettingStat();
			betStats.resourceUrl = () => {
				return `${betStats.baseUrl()}/users/${userId}/betting_stats`;
			};

			return betStats
				.where('from', dayjs(from).format('YYYY-MM-DD'), 'created_at')
				.where('to', dayjs(to).format('YYYY-MM-DD'), 'created_at')
				.get()
				.then((results) => {
					set(results.data);
					return results;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
